__turbopack_context__.v({
  "box": "HomePage-module-scss-module__kV3c4a__box",
  "textAlignCenter": "HomePage-module-scss-module__kV3c4a__textAlignCenter",
  "typography": "HomePage-module-scss-module__kV3c4a__typography",
});
